import { useDispatch, useSelector } from "react-redux";
import { encryptCTC, showNotification } from "../../../shared/utils/utils";
import { RootState } from "../../../shared/types/common";
import { Button, Drawer, Form, Tooltip, Upload, UploadFile } from "antd";
import GenericFormComponent from "../../../shared/components/generic-form/generic-form.component";
import { useForm } from "antd/lib/form/Form";
import {
  createStaff,
  updateStaffById,
} from "../../../core/store/reducers/staff.slice";
import moment, { min } from "moment";
import { useEffect, useState } from "react";
import { Client } from "../../../core/api-client";
import {
  API_GET_ALL_ACCOUNTS_LIST,
  API_GET_ALL_DEPARTMENT_LIST,
  API_GET_ALL_PROJECT_LIST,
  API_GET_ALL_STAFF_LIST,
  API_GET_ALL_VENDOR_LIST,
} from "../../../shared/routes/private.routes";
import {
  ExclamationCircleOutlined,
  InboxOutlined,
  QuestionCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  getDocuments,
  getSignedUrl,
} from "../../../core/store/reducers/activity-log.slice";
import { getSubDepartmentsByDepartment } from "../../../core/store/reducers/sub-department.slice";
import { requestGetByModuleCommon } from "../../../core/store/reducers/master.slice";
import { getAccountsByEntity } from "../../../core/store/reducers/accounts.slice";
interface Props {
  onClose: () => void;
  visible: boolean;
  selectedEntity?: any;
  onSubmit?: () => void;
}
const CreateEditStaffComponent = ({
  onClose,
  visible,
  selectedEntity = null,
  onSubmit = () => {
    return;
  },
}: Props) => {
  const dispatch = useDispatch();
  const [form] = useForm();
  const { user } = useSelector((state: RootState) => state.auth);
  const { screenType } = useSelector((state: RootState) => state.settings);
  const [staffList, setStaffList] = useState<any[]>([]);
  const [projectList, setProjectList] = useState<any[]>([]);
  const [genderList, setGenderList] = useState<any[]>([]);
  const [entityList, setEntityList] = useState<any[]>([]);
  const [employmentModes, setEmploymentModes] = useState<any[]>([]);
  const [employeeTypes, setEmployeeTypes] = useState<any[]>([]);
  const [currencies, setCurrencies] = useState<any[]>([]);
  const [departmentList, setDepartmentList] = useState<any[]>([]);
  const [subDepartmentList, setSubDepartmentList] = useState<any[]>([]);
  const [vendorList, setVendorList] = useState<any[]>([]);
  const [selectedStartDate, setSelectedStartDate] = useState<any>(null);
  const [showVendorField, setShowVendorField] = useState<boolean>(false);
  const [fileList, setFileList] = useState<UploadFile<any>[]>([]);
  const [documents, setDocuments] = useState<any[]>([]);
  const [departmentId, setDepartmentId] = useState<any>("")
  const [accountList, setAccountList] = useState<any[]>([]);
  const [filteredProjectList,setFilteredProjectList] = useState<any[]>([]);
  const onFinish = async (values: any) => {
    // Split fileList into two groups
    const oldFiles = fileList.filter((file) => !file.originFileObj); // previously uploaded
    const newFiles = fileList.filter((file) => file.originFileObj); // new uploads
    const formData = new FormData();
    const doj = values.doj ? new Date(values.doj).toISOString() : null;
    const lwd = values?.lwd ? new Date(values?.lwd).toISOString() : null;
    const currentProjectStartDate = values?.currentProjectStartDate ? new Date(values?.currentProjectStartDate).toISOString() : null;
    const projectReleaseDate = values?.projectReleaseDate
      ? new Date(values?.projectReleaseDate).toISOString()
      : null;

    // Append all string/number fields
    formData.append("staffName", values?.staffName);
    formData.append("employeeType", values?.employeeType);
    formData.append("employeeId", values?.employeeId);
    formData.append("email", values?.email || "");
    formData.append("gender", values?.gender || "");
    formData.append("staffTypeId", values?.type || "");
    formData.append("staffSubTypeId", values?.subtype || "");
    formData.append("staffStatusId", values?.staffStatus);
    formData.append("doj", doj || "");
    formData.append("lwd", lwd || "");
    formData.append("departmentId", values?.department);
    formData.append("subDepartmentId",values?.subDepartment || "");
    formData.append("accountId", values?.client || "");
    formData.append("projectId", values?.project || "");
    formData.append("subProjectId", values?.subProject || "");
    formData.append("projectReleaseDate", projectReleaseDate || "");
    formData.append("currentProjectStartDate", currentProjectStartDate || "");
    formData.append("lineManagerId", values?.linemanager || "");
    formData.append("vendorId", values?.vendor || "");
    formData.append("entity", values?.entity);
    formData.append("employmentMode", values?.employmentMode);
    formData.append("designation", values?.designation || "");
    formData.append("role", values?.role || "");
    formData.append("noticePeriod", values?.noticePeriod || "");
    formData.append("costToRd", values?.costToRd || "");

    if(!selectedEntity){
      formData.append("salaryCurrency",values?.salaryCurrency)
      // formData.append("ctc", values?.ctc);
      let {encrypted_ctc, iv, salt} = await encryptCTC(moment().format("YYYY-MM-DD"), values?.ctc?.toString());
      formData.append("encrypted_ctc", encrypted_ctc);
      formData.append("iv", iv);
      formData.append("salt", salt);
      // formData.append("employeeCost", values?.employeeCost || "");
    }

    // Append file (assuming single file upload)
    if (fileList && newFiles.length > 0) {
      newFiles.forEach((fileItem) => {
        const file = fileItem;
        formData.append("files", file.originFileObj as File); // use consistent key name
      });
    }
    const remainingOldFiles = oldFiles.map((file) => ({
      uid: file.uid,
      name: file.name,
      url: file.url,
    }));
    formData.append("oldFiles", JSON.stringify(remainingOldFiles));

    if (selectedEntity) {
      dispatch(
        updateStaffById({ staffId: selectedEntity?.staffId, formData })
      ).then((val: any) => {
        if (val?.payload?.data && val?.payload?.data?.statusCode === 200) {
          showNotification("Staff Details Updated Successfully", "success");
          onSubmit();
        }
        if (val?.payload?.data && val?.payload?.data?.statusCode === 400) {
          if (val?.payload?.data?.message === "staffAlreadyExistMessage") {
            showNotification("Staff Already Exist", "warning");
          } else {
            showNotification(val?.payload?.data?.message, "warning");
          }
        }
      });
    } else {
      dispatch(createStaff(formData)).then((val: any) => {
        if (val?.payload?.data && val?.payload?.data?.statusCode === 200) {
          showNotification("New Staff Created Successfully", "success");
          onSubmit();
        }
        if (val?.payload?.data && val?.payload?.data?.statusCode === 400) {
          if (val?.payload?.data?.message === "staffAlreadyExistMessage") {
            showNotification("Staff Already Exist", "warning");
          } else {
            showNotification(val?.payload?.data?.message, "warning");
          }
        }
      });
    }
  };

  const fetchStaffList = async () => {
    const response = await Client.get(API_GET_ALL_STAFF_LIST);
    if (response?.data?.data) {
      setStaffList(response?.data?.data);
    } else {
      setStaffList([]);
    }
  };

  const fetchProjectList = async () => {
    const response = await Client.get(API_GET_ALL_PROJECT_LIST);
    if (response?.data?.data) {
      setProjectList(response?.data?.data);
    } else {
      setProjectList([]);
    }
  };

  const fetchFilteredProjectList = async (clientId: string) => {
    const response = projectList.filter((project:any)=>project.accountId === clientId);
    setFilteredProjectList(response);
  };
  const fetchDepartmentList = async () => {
    const response = await Client.get(API_GET_ALL_DEPARTMENT_LIST);
    if (response?.data?.data) {
      setDepartmentList(response?.data?.data);
    } else {
      setDepartmentList([]);
    }
  };

  const fetchVendorList = async () => {
    const response = await Client.get(API_GET_ALL_VENDOR_LIST);
    if (response?.data?.data) {
      setVendorList(response?.data?.data);
    } else {
      setVendorList([]);
    }
  };

  useEffect(() => {
    if (selectedEntity) {
      form.setFieldsValue({
        staffName: selectedEntity?.staffName,
        employeeType: selectedEntity?.employeeType,
        employeeId: selectedEntity?.employeeId,
        email: selectedEntity?.email,
        gender: selectedEntity.gender,
        type: selectedEntity?.staffTypeId,
        subtype: selectedEntity?.staffSubTypeId,
        staffStatus: selectedEntity?.staffStatusId,
        doj: moment(selectedEntity?.doj),
        lwd: selectedEntity?.lwd ? moment(selectedEntity?.lwd) : null,
        department: selectedEntity?.departmentId,
        subDepartment: selectedEntity?.subDepartmentId || null,
        client: selectedEntity?.accountId || null,
        project: selectedEntity?.projectId || null,
        subProject: selectedEntity?.subProjectId || null,
        projectReleaseDate: selectedEntity?.projectReleaseDate
          ? moment(selectedEntity?.projectReleaseDate)
          : null,
        currentProjectStartDate: selectedEntity?.currentProjectStartDate
        ? moment(selectedEntity?.currentProjectStartDate)
        : null,
        linemanager: selectedEntity?.lineManagerId || null,
        ctc: selectedEntity?.ctc,
        vendor: selectedEntity?.vendorId,
        entity: selectedEntity?.entity,
        employmentMode: selectedEntity?.employmentMode,
        designation: selectedEntity?.designation || null,
        role: selectedEntity?.role || null,
        noticePeriod: selectedEntity?.noticePeriod || null,
        // employeeCost: selectedEntity?.employeeCost || null,
        costToRd: selectedEntity?.costToRd || null,
        salaryCurrency: selectedEntity?.salaryCurrency
      });
      const filterEmploymentMode = employmentModes.find((type:any)=>type.name === 'Vendor Consultant')
      if (selectedEntity?.employmentMode === filterEmploymentMode?.id) {
        setShowVendorField(true); // Show vendor field if employee type is Vendor
      }
      setDepartmentId(selectedEntity?.departmentId);
      const employeeCost = parseFloat((selectedEntity?.ctc / 12).toFixed(2));
      form.setFieldsValue({ employeeCost });
      fetchAccountListByEntity(selectedEntity?.entity);
      // Only filter projects if projectList is already loaded
      if (selectedEntity?.accountId && projectList.length > 0) {
        fetchFilteredProjectList(selectedEntity?.accountId);
      }
    }
  }, [form, selectedEntity, projectList, employmentModes]);

  useEffect(() => {
    fetchStaffList();
    fetchProjectList();
    fetchDepartmentList();
    fetchVendorList();
    fetchDocumentList();
    fetchGenderList();
    fetchEntityList();
    fetchEmploymentModes();
    fetchEmployeeTypes();
    fetchCurrencies();
  }, []);

  const fetchGenderList = async () => {
    try {
      const response = await dispatch(
        requestGetByModuleCommon({ module: "master_gender" })
      ).unwrap();
      // console.log(response.data);
      if (response?.success) {
        setGenderList(response?.data.items);
      }
    } catch (error) {}
  };
  const fetchCurrencies = async () => {
    try {
      const response = await dispatch(
        requestGetByModuleCommon({ module: "master_currency" })
      ).unwrap();
      // console.log(response.data);
      if (response?.success) {
        setCurrencies(response?.data.items);
      }
    } catch (error) {}
  };
  const fetchEntityList = async () => {
    try {
      const response = await dispatch(
        requestGetByModuleCommon({ module: "master_entity" })
      ).unwrap();
      // console.log(response.data);
      if (response?.success) {
        setEntityList(response?.data.items);
      }
    } catch (error) {}
  };
  const fetchEmploymentModes = async () => {
    try {
      const response = await dispatch(
        requestGetByModuleCommon({ module: "master_employment_mode" })
      ).unwrap();
      // console.log(response.data);
      if (response?.success) {
        setEmploymentModes(response?.data.items);
      }
    } catch (error) {}
  };
  const fetchEmployeeTypes = async () => {
    try {
      const response = await dispatch(
        requestGetByModuleCommon({ module: "master_employee_type" })
      ).unwrap();
      // console.log(response.data);
      if (response?.success) {
        setEmployeeTypes(response?.data.items);
      }
    } catch (error) {}
  };
  const fetchDocumentList = async () => {
    if (selectedEntity?.staffId) {
      const response = await dispatch(
        getDocuments(selectedEntity?.staffId)
      ).unwrap();
      if (response?.data) {
        setDocuments(response?.data);
        console.log(response?.data, "fetchDocumentList");
      }
    }
  };
  const fetchAccountListByEntity = async (entity: string) => {
    const response = await dispatch(getAccountsByEntity(entity)).unwrap();
    if (response?.data?.data) {
      setAccountList(response?.data?.data);
    } else {
      setAccountList([]);
    }
  };
  useEffect(() => {
    if(departmentId){
      fetchSubDepartmentsList(departmentId);
    }
    
  },[departmentId])
  const fetchSubDepartmentsList = async (departmentId: string) => {
    if (departmentId) {
      const response = await dispatch(
        getSubDepartmentsByDepartment(departmentId)
      ).unwrap();
      if (response?.data) {
        setSubDepartmentList(response?.data);
        console.log(response?.data?.data, "fetchSubDepartmentsList");
      }
    }
  };

  useEffect(() => {
    if (documents?.length) {
      const converted = documents.map((doc) => ({
        uid: doc.id,
        name: doc.originalFileName,
        status: "done",
        url: doc.bucketPath || "",
      }));

      // Optional: prevent unnecessary state update
      setFileList((prev: any) => {
        const same = JSON.stringify(prev) === JSON.stringify(converted);
        return same ? prev : converted;
      });
    } else {
      setFileList([]); // Clear fileList if documents are empty
    }
  }, [documents]);
  console.log(fileList, "filelist");

  const staffDropdownOptions = staffList.map((staff) => ({
    value: staff?.staffId,
    label: staff?.staffName,
  }));

  const projectDropdownOptions = filteredProjectList.map((project) => ({
    value: project?.projectId,
    label: project?.l2ProjectName,
  }));

  const departmentDropdownOptions = departmentList.map((department) => ({
    value: department?.departmentId,
    label: department?.departmentName,
  }));
  const subDepartmentDropdownOptions = subDepartmentList.map((subDepartment) => ({
    value: subDepartment?.id,
    label: subDepartment?.subDepartmentName,
  }));

  const vendorDropdownOptions = vendorList.map((vendor) => ({
    value: vendor?.vendorId,
    label: vendor?.vendorName,
  }));

  const onFinishFailed = (_errorInfo: any) => {
    return;
  };

  const onValuesChange = (changedValues: any, allValues: any) => {
    if ("entity" in changedValues) {
      fetchAccountListByEntity(changedValues.entity);
      form.setFieldsValue({ client: undefined });
    }
    // Track start date
    if ("doj" in changedValues) {
      setSelectedStartDate(allValues.doj);
    }
  
    // Toggle vendor field based on employment mode
    if ("employmentMode" in changedValues) {
      const filterEmploymentMode = employmentModes.find((type:any)=>type.name === 'Vendor Consultant')
      const isVendor = changedValues.employmentMode === filterEmploymentMode?.id;
      setShowVendorField(isVendor);
      form.setFieldsValue({ vendor: undefined }); // Clear vendor field either way
    }
  
    // Track department change
    if ("department" in changedValues) {
      setDepartmentId(changedValues.department);
    }

    if ("ctc" in changedValues) {
      const employeeCost = parseFloat((allValues.ctc / 12).toFixed(2));
      form.setFieldsValue({ employeeCost });
    }
    if ("client" in changedValues) {
      // Clear project when client changes
      form.setFieldsValue({ project: undefined });
      // Only filter if a client is actually selected
      if (changedValues.client) {
        fetchFilteredProjectList(changedValues.client);
      } else {
        // Clear filtered projects if client is cleared
        setFilteredProjectList([]);
      }
    }
  };

  const disabledDate = (current: moment.Moment | null) => {
    // Disable dates before the start date
    return current && current < moment(selectedStartDate).endOf("day");
  };

  const handleUploadChange = (info: any) => {
    const { file, fileList } = info;

    // Optional: filter duplicates by UID or name
    const uniqueFileList = fileList.filter(
      (file: { uid: any }, index: any, self: any[]) =>
        index === self.findIndex((f) => f.uid === file.uid)
    );

    console.log(uniqueFileList, "uniqueFileList");
    setFileList(uniqueFileList);

    if (file.status === "done" || !file.status) {
      showNotification(`${file.name} file uploaded successfully.`, "success");
    } else if (file.status === "error") {
      showNotification(`${file.name} file upload failed.`, "error");
    }
  };

  const beforeUpload = async (file: any) => {
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ];
  
    const isValidType = allowedTypes.includes(file.type);
  
    if (!isValidType) {
      showNotification("Only PDF or Word files are allowed", "warning");
      return Upload.LIST_IGNORE;
    }
  
    return false; // Prevent auto upload if you're using customRequest
  };

  const handleRemove = (file: any) => {
    // const updatedList = fileList.filter((f) => f.uid !== file.uid);
    // setFileList(updatedList);
  };
  const handleCustomRequest = ({ file, onSuccess }: any) => {
    // Simulate upload success after 0ms
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  var colSpan = screenType?.isPortrait ? 24 : 12;
  const formProps = {
    form: form,
    name: "creat-edit-staff",
    heading: selectedEntity ? "Edit Staff Details" : "Add New Staff",
    initialValues: {
      staffStatus: "ACTIVE",
      ctc: 0
    },
    formElements: [
      {
        name: "staffName",
        colSpan: 12,
        label: "Staff Name",
        placeholder: "Enter Staff Name ",
        type: "Input",
        allowClear: true,
        rules: [{ required: true, message: "Please enter Staff Name" }],
      },
      {
        name: "entity",
        label: "Entity",
        placeholder: "Entity",
        type: "Select",
        rules: [{ required: true, message: "Please select Entity" }],
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: entityList?.map((entity) => ({
          value: entity?.id,
          label: entity?.name,
        })),
      },
      {
        name: "employeeId",
        colSpan: 12,
        label: "Employee Id",
        placeholder: "Enter Employee Id",
        type: "Input",
        allowClear: true,
        fieldProps: {
          suffix: (
            <Tooltip title="Format: 2–3 letters followed by 5 digits (e.g., RD12345 or RDM12345)">
              <ExclamationCircleOutlined
                style={{ cursor: "pointer", color: "#999" }}
              />
            </Tooltip>
          ),
        },
        rules: [
          { required: true, message: "Please enter Employee Id" },
          {
            validator: (_: any, value: string) => {
              if (!value) return Promise.resolve();
              const regex = /^[A-Za-z]{2,3}[0-9]{5}$/;
              return regex.test(value)
                ? Promise.resolve()
                : Promise.reject(
                    new Error("Invalid format. Please check the Info.")
                  );
            },
          },
        ],
      },
      {
        name: "email",
        label: "Email",
        placeholder: "Enter Email",
        type: "Input",
        rules: [
          {
            required: false,
            message: "Please enter Email",
          },
          {
            validator: (_: any, value: string) => {
              // Only run this validator if there is a value
              if (!value) return Promise.resolve(); // Let "required" handle empty

              // Run only if the value is a valid email first (optional defensive check)
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailRegex.test(value)) return Promise.resolve(); // Let 'type: email' handle this

              // Now check domain
              if (value.toLowerCase().endsWith("@roboticodigital.com")) {
                return Promise.resolve();
              }

              return Promise.reject(
                new Error("Email must end with @roboticodigital.com")
              );
            },
          },
        ],
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
      },
      {
        name: "gender",
        label: "Gender",
        placeholder: "Gender",
        type: "Select",
        rules: [{ required: true, message: "Please enter Gender" }],
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: genderList?.map((gender) => ({
          value: gender?.id,
          label: gender?.name,
        })),
      },
      {
        name: "staffStatus",
        label: "Staff Status",
        placeholder: "Staff Status",
        type: "Select",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: [
          { value: "ACTIVE", label: "ACTIVE" },
          { value: "INACTIVE", label: "INACTIVE" },
          { value: "NOTICE PERIOD", label: "NOTICE PERIOD" },
        ],
        rules: [{ required: true, message: "Please enter Staff Status" }],
      },
      {
        name: "employmentMode",
        label: "Employment Mode",
        placeholder: "Employment Mode",
        type: "Select",
        rules: [{ required: true, message: "Please select Employment Mode" }],
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: employmentModes?.map((employmentMode) => ({
          value: employmentMode?.id,
          label: employmentMode?.name,
        })),
      },
      {
        name: "employeeType",
        label: "Employee Type",
        placeholder: "Employee Type",
        type: "Select",
        rules: [{ required: true, message: "Please enter Employee Type" }],
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: employeeTypes?.map((employeeType) => ({
          value: employeeType?.id,
          label: employeeType?.name,
        })),
      },

      // {
      //   name: "type",
      //   label: "Staff Type",
      //   placeholder: "Staff Type",
      //   type: "Select",
      //   rules: [{ message: "Please enter Staff Type" }],
      //   colSpan: colSpan,
      //   showSearch: true,
      //   allowClear: true,
      //   options: [
      //     { value: "admin", label: "Admin" },
      //     { value: "hr", label: "HR" }
      //   ],
      // },
      // {
      //   name: 'subtype',
      //   label: 'Staff Sub Type',
      //   placeholder: 'Staff Sub Type',
      //   rules: [{ message: "Please enter Staff Sub Type" }],
      //   type: 'Select',
      //   colSpan: colSpan,
      //   showSearch: true,
      //   allowClear: true,
      //   options: [
      //     { value: 'admin', label: 'Admin' },
      //     { value: "hrmanager", label: "HR Manager" }
      // ],

      // },
      {
        name: "designation",
        colSpan: 12,
        label: "Designation",
        placeholder: "Enter Designation ",
        type: "Input",
        allowClear: true,
        rules: [{ required: false, message: "Please enter Designation" }],
      },
      {
        name: "role",
        colSpan: 12,
        label: "Role",
        placeholder: "Enter Role ",
        type: "Input",
        allowClear: true,
        rules: [{ required: false, message: "Please enter Role" }],
      },
      {
        name: "doj",
        label: "Date of Joining",
        placeholder: "Date of Joining",
        type: "DatePicker",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        rules: [{ required: true, message: "Please enter Date of Joining" }],
      },
      {
        name: "lwd",
        label: "Last Working Day",
        placeholder: "Last Working Day",
        type: "DatePicker",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        rules: [{ required: false, message: "Please enter Last Working Day" }],
        disabledDate: disabledDate,
      },
      {
        name: "department",
        label: "Department",
        placeholder: "Department",
        type: "Select",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: departmentDropdownOptions,
        rules: [{ required: true, message: "Please enter Department" }],
      },
      {
        name: "subDepartment",
        label: "Sub Department",
        placeholder: "Sub Department",
        type: "Select",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: subDepartmentDropdownOptions,
        rules: [{ required: false, message: "Please select Sub Department" }],
      },
      // {
      //   name: "client",
      //   label: "Client",
      //   placeholder: "Client",
      //   type: "Select",
      //   colSpan: colSpan,
      //   showSearch: true,
      //   allowClear: true,
      //   options: accountList?.map((account) => ({
      //     value: account?.accountId,
      //     label: account?.accountName,
      //   })),
      //   rules: [{ message: "Please enter Client" }],
      // },  
      // {
      //   name: "project",
      //   label: "Project",
      //   placeholder: "Project",
      //   type: "Select",
      //   colSpan: colSpan,
      //   showSearch: true,
      //   allowClear: true,
      //   options: projectDropdownOptions,
      //   rules: [{ message: "Please enter Project" }],
      // },
      // // {
      // //   name: "subProject",
      // //   label: "Sub Project",
      // //   placeholder: "Sub Project",
      // //   type: "Select",
      // //   colSpan: colSpan,
      // //   showSearch: true,
      // //   allowClear: true,
      // //   options: projectDropdownOptions,
      // //   rules: [{ message: "Please enter Sub Project" }],
      // // },
      // {
      //   name: "currentProjectStartDate",
      //   label: "Current Project Start Date",
      //   placeholder: "Current Project Start Date",
      //   type: "DatePicker",
      //   colSpan: colSpan,
      //   showSearch: true,
      //   allowClear: true,
      //   rules: [
      //     { required: false, message: "Please enter Current Project Start Date" },
      //   ],
      // },
      // {
      //   name: "projectReleaseDate",
      //   label: "Project Release Date",
      //   placeholder: "Project Release Date",
      //   type: "DatePicker",
      //   colSpan: colSpan,
      //   showSearch: true,
      //   allowClear: true,
      //   rules: [
      //     { required: false, message: "Please enter Project Release Date" },
      //   ],
      // },
      {
        name: "linemanager",
        label: "Line Manager",
        placeholder: "Line Manager",
        type: "Select",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: staffDropdownOptions,
        rules: [{ message: "Please enter Line Manager" }],
      },
      !selectedEntity && {
        name: "salaryCurrency",
        label: "Salary Currency",
        placeholder: "Salary Currency",
        type: "Select",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: currencies?.map((Currency) => ({
          value: Currency?.id,
          label: Currency?.name,
        })),
        rules: [{ required: true, message: "Please enter Salary Currency" }],
      },
      !selectedEntity && {
        name: "ctc",
        colSpan: 12,
        label: "CTC (Annual)",
        placeholder: "Enter CTC",
        type: "InputNumber",
        isAmount: true,
        allowClear: true,
        min: 0,
        rules: [{ required: true, message: "Please enter CTC" }],
      },
      !selectedEntity && {
        name: "employeeCost",
        colSpan: 12,
        label: "Monthly Salary",
        placeholder: "Enter Monthly Salary",
        type: "InputNumber",
        disabled: true,
        isAmount: true,
        allowClear: true,
        min: 0,
        rules: [{ required: false, message: "Please enter Monthly Salary" }],
      },
      {
        name: "noticePeriod",
        colSpan: 12,
        label: "Notice Period (Days)",
        placeholder: "Enter Notice Period",
        type: "Input",
        allowClear: true,
        min: 0,
        rules: [{ required: false, message: "Please enter Notice Period" }],
        fieldProps: {
          onChange: (e: any) => {
            const onlyNums = e.target.value.replace(/\D/g, "");
            e.target.value = onlyNums; // optional - doesn't control input
            e.currentTarget.value = onlyNums; // for React event
          },
          inputMode: "numeric", // mobile-friendly numeric keypad
          onKeyDown: (e: any) => {
            // Prevent typing non-numeric characters
            if (
              !/[0-9]/.test(e.key) &&
              e.key !== "Backspace" &&
              e.key !== "Delete" &&
              e.key !== "ArrowLeft" &&
              e.key !== "ArrowRight"
            ) {
              e.preventDefault();
            }
          },
        },
      },
      showVendorField && {
        name: "costToRd",
        colSpan: 12,
        label: "Cost to RD",
        placeholder: "Enter Cost to RD",
        type: "InputNumber",
        allowClear: true,
        isAmount:true,
        min: 0,
        rules: [{ required: false, message: "Please enter Cost to RD" }],
      },
      showVendorField && {
        name: "vendor",
        label: "Vendor",
        placeholder: "Vendor",
        type: "Select",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: vendorDropdownOptions,
        rules: [{ required: showVendorField, message: "Please enter Vendor" }],
      },
      {
        name: "files", // or any identifier
        label: "Upload File",
        type: "Custom",
        colSpan: 16,
        render: ({} = {}) => (
          <Form.Item
            name="file"
            valuePropName="fileList"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
            rules={[{ required: false }]}
          >
            <div style={{ maxHeight: 400 }}>
              <Upload.Dragger
                name="file"
                multiple={true}
                listType="text"
                showUploadList={{ showRemoveIcon: true }}
                fileList={fileList}
                onChange={handleUploadChange}
                onRemove={handleRemove}
                customRequest={handleCustomRequest}
                beforeUpload={beforeUpload}
                accept=".pdf,.doc,.docx"
                style={{ padding: "16px 0", backgroundColor: "#dcdcdc" }}
                onPreview={async (file) => {
                  try {
                    console.log(file);
                    if (file.url) {
                      const res = await dispatch(
                        getSignedUrl({
                          module: "staff",
                          params: { url: file.url },
                        })
                      ).unwrap();

                      console.log(res, getSignedUrl);
                      if (res?.data?.url) {
                        window.open(res.data.url, "_blank");
                      }
                    }
                  } catch (e) {
                    console.log("Could not open file");
                  }
                }}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Upload.Dragger>
            </div>
          </Form.Item>
        ),
      },
    ],
    extraButtons: [
      {
        htmlType: "button",
        colSpan: 5,
        loading: false,
        submitButtonText: "Cancel",
        onClick: onClose,
      },
      {
        htmlType: "button",
        colSpan: 5,
        loading: false,
        submitButtonText: "Clear",
        type: "clearForm",
      },
      {
        htmlType: "submit",
        colSpan: 5,
        loading: false,
        submitButtonText: "Save",
        submitButtonType: "primary",
      },
    ],
    onFinish: onFinish,
    onFinishFailed: onFinishFailed,
    onValuesChange: onValuesChange,
  };
  return (
    <>
      <Drawer
        maskClosable={false}
        title={<strong>{formProps.heading}</strong>}
        className="form-drawer"
        width={
          screenType.isPortrait
            ? "90%"
            : screenType.isLg || screenType.isXl
            ? 720
            : 500
        }
        onClose={onClose}
        open={visible}
      >
        <GenericFormComponent {...formProps} />
      </Drawer>
    </>
  );
};

export default CreateEditStaffComponent;
